<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/R1RVSO/tc-custom/9781504079488.jpg?1705026307367" alt="This image is the cover for the book I Am From Brownsville"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Am From Brownsville
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The classic story collection brings to life a close-knit Jewish neighborhood of Brooklyn as a group of boys make their journey to adulthood.</b></p> In these thirteen stories Arthur Granit introduces readers to the lost world of Brownsville as it was in the 1920s. As neighborhood boys grow up together through adventures and misadventures, friendships and trials, Granit observes their evolution against the backdrop of a changing city. Here is the wild humor—and occasional sadness—of life in a teeming Brooklyn Jewish community.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Arthur Granit
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Philosophical Library/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?53c77a30